
import { Component, Prop, Vue } from "vue-property-decorator";
import Typewriter from "./Typewriter.vue";

@Component({
  components: { Typewriter },
})
export default class Title extends Vue {
  @Prop({default: []})
  items?: any[];
}
